import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../ModalDialog';
import './_styles_/ConfirmPopup.css';

ConfirmPopup.propTypes = {
    message: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

function ConfirmPopup(props) {
    const {
        message,
        onConfirm,
        onCancel,
    } = props;
    const { t } = useTranslation();
    return (
        <ModalDialog onCancel={onCancel}>
            <div className="confirm-popup-dialog" role="dialog" aria-modal>
                <span className="message" aria-label={message}>{message}</span>
                <div className="buttons">
                    <button type="button" className="yes-button button-filled-red button" onClick={onConfirm}>{t('button.yes')}</button>
                    <button type="button" className="no-button button-bordered button" onClick={onCancel}>{t('button.no')}</button>
                </div>
            </div>
        </ModalDialog>
    );
}

export default ConfirmPopup;
